import {imageMap} from "../../../../images/imageMap.ts";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";

export default function SpeedAndDuplexArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <h2>                            
                            Speed & Duplex
                        </h2>
                        <p>
                            I Windows kan du konfigurere Speed & Duplex for et netværkskort via netværksindstillingerne.
                        </p>
                        <p>
                            Speed & Duplex er en netværksindstilling, der bestemmer hastigheden på din forbindelse, og om data kan sendes begge veje samtidig.
                        </p>
                        <p>    
                            Speed & Duplex sikrer, at dit netværk kører stabilt og hurtigt.
                            Nogle gange kan din hastighed blive hurtigere, hvis du indstiller Speed & Duplex.
                        </p>
                         <p>   
                            På en computer kan netværkskortet f.eks. være indstillet til ikke at understøtte 1000 Mbit.
                        </p>
                        <p>
                            Nedenfor finder du Windows- og Mac-vejledning til at understøtte 1000 Mbit vha. Speed & Duplex:
                        </p>

                        <h3>
                            Windows
                        </h3>
                        <ol className="list list--number list--image">
                            <li>  
                                <p>
                                    Åbn <strong>Enhedshåndtering</strong> på din PC.
                                    Du kan søge det frem i søgefeltet.
                                </p>
                            </li>
                            <li>  
                                <p>
                                    Åbn <strong>Netværkskort.</strong>
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.aabenNetvaerkskort}
                                alt="Hvordan vælger man netværkskort."
                            />
                            <li> 
                                <p>
                                    Højreklik på netværkskortet, der påvirker dit internet.
                                    Det har typisk en ordlyd a la <strong>Ethernet</strong> eller <strong>Gbe.</strong>
                                </p> 
                            </li>
                            <li>  
                                <p>
                                    Tryk på <strong>Egenskaber.</strong>  
                                </p>                     
                            </li>
                            <img
                                src={imageMap.help.network.advanceret}
                                alt="Vælg advanceret."
                            />
                            <li>
                                <p>
                                    Tryk på <strong>Avanceret.</strong>
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.advanceretEgenskaber}
                                alt="Vælg advanceret egenskaber."
                            />
                            <li>
                                <p>
                                    Vælg <strong>Speed & Duplex</strong> under <strong>Egenskab.</strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Vælg <strong>1.0 Gbps Full Duplex</strong> under <strong>Værdi.</strong>
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.speedandduplexWin}
                                alt="Vælg full duplex."
                            />
                            <li>
                                <p>
                                    Tryk <strong>OK.</strong> Nu understøtter dit netværkskort 1000 Mbit!
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>                            
                            Mac OS
                        </h2>
                        <ol className="list list--number list--image">
                            <li>
                                <p>
                                    Åbn <strong>Systemindstillinger</strong> på din Mac.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Vælg <strong>Netværk.</strong>
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.opennetworkmac}
                                alt="Vælg netværk."
                            />
                            <li>
                                <p>
                                    Klik på <strong>Thunderbolt Ethernet</strong> i venstre side af skærmen.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Vælg <strong>Avanceret.</strong>
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.thunderboltethernetmac}
                                alt="Vælg thunderbolt ethernet."
                            />
                            <li>
                                <p>
                                    Vælg <strong>Hardware</strong> under <strong>Avanceret.</strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Sæt <strong>Hastighed</strong> til <strong>1000baseT.</strong>
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.baseTmac}
                                alt="Vælg 1000base T."
                            />
                            <li>
                                <p>
                                    Sæt <strong>Dupleks</strong> til <strong>fuld dupleks.</strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Tryk <strong>OK.</strong> Nu understøtter dit netværkskort 1000 Mbit! 
                                </p>
                            </li>                            
                        </ol>
                        <p>
                            Herefter vil det være oplagt at teste din hastighed på ny, og se om ændringen har hjulpet.
                            Du kan læse meget mere om test af internethastighed <Link to={'/hjaelp/internet-og-wifi/hastighedstest'}>her!</Link>
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "forventninger-til-wifi",
                        "name": "Hvad kan jeg forvente af mit wifi?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4 GHz og 5 GHz"
                    }
                ]}
            />
        </>
    )
}
